<app-offline-indicator></app-offline-indicator>
<router-outlet></router-outlet>
